// import React, { useEffect, useState } from "react";
// import api from "../services/httpService";
// import "./Specialization.css";

// const Specialization = () => {
//   const [specialItems, setSpecialItems] = useState([]);

//   // Fetch specials from backend
//   useEffect(() => {
//     fetchSpecialItems();
//   }, []);

//   const fetchSpecialItems = async () => {
//     try {
//       const res = await api.get("/sentinix/specials");
//       if (res.data.success) {
//         const items = res.data.data.filter(
//           (item) => !item.isDeleted && item.isActive
//         );
//         setSpecialItems(items);
//       }
//     } catch (err) {
//       console.error("Error fetching specials:", err);
//     }
//   };

//   // Intersection Observer for animation
//   useEffect(() => {
//     const items = document.querySelectorAll(".specialization-item");

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("in-view");
//           } else {
//             entry.target.classList.remove("in-view");
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     items.forEach((item) => observer.observe(item));
//     return () => observer.disconnect();
//   }, [specialItems]);

//   return (
//     <div>
//       <h3 className="title">Our Specialization</h3>

//       <div className="specialization-container">
//         {specialItems.length === 0 ? (
//           <p style={{ textAlign: "center" }}>No specials added yet.</p>
//         ) : (
//           specialItems.map((item) => (
//             <div key={item.id} className="specialization-item">
//               <div className="specialization-image-container">
//                 <img
//                   src={item.imageKey || ""}
//                   alt={item.title}
//                   className="specialization-image"
//                 />
//               </div>
//               <div className="specialization-text">
//                 <h4 className="specialization-title">{item.title}</h4>
//                 {item.description.split("\n").map((line, index) => (
//                   <p key={index} className="specialization-description">
//                     {line}
//                   </p>
//                 ))}
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default Specialization;

import React, { useEffect, useState } from "react";
import api from "../services/httpService";
import "./Specialization.css";

const Specialization = () => {
  const [specialItems, setSpecialItems] = useState([]);
  // const [themeColors, setThemeColors] = useState({
  //   color1: "#f83600",
  //   color2: "#fe8c00"
  // });

  // Fetch specials from backend
  useEffect(() => {
    fetchSpecialItems();
    fetchThemeColors();
  }, []);

  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];

        if (latest) {
          const color1 = latest.color1 || "#f83600";
          const color2 = latest.color2 || "#fe8c00";
          
          //setThemeColors({ color1, color2 });
          
          // Apply to CSS variables
          document.documentElement.style.setProperty("--theme-color1", color1);
          document.documentElement.style.setProperty("--theme-color2", color2);
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  const fetchSpecialItems = async () => {
    try {
      const res = await api.get("/sentinix/specials");
      if (res.data.success) {
        const items = res.data.data.filter(
          (item) => !item.isDeleted && item.isActive
        );
        setSpecialItems(items);
      }
    } catch (err) {
      console.error("Error fetching specials:", err);
    }
  };

  // Intersection Observer for animation
  useEffect(() => {
    const items = document.querySelectorAll(".specialization-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, [specialItems]);

  return (
    <div>
      <h3 className="title">Our Specialization</h3>

      <div className="specialization-container">
        {specialItems.length === 0 ? (
          <p style={{ textAlign: "center" }}>No specials added yet.</p>
        ) : (
          specialItems.map((item) => (
            <div key={item.id} className="specialization-item">
              <div className="specialization-image-container">
                <img
                  src={item.imageKey || ""}
                  alt={item.title}
                  className="specialization-image"
                />
              </div>
              <div className="specialization-text">
                <h4 className="specialization-title">{item.title}</h4>
                {item.description.split("\n").map((line, index) => (
                  <p key={index} className="specialization-description">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Specialization;